import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Case } from '../../_types/case';
import { Company } from 'src/app/modules/companies/_types/company';
import { CasesService } from '../../_services/cases.service';
import { CompaniesService } from 'src/app/modules/companies/_services/companies.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { first, firstValueFrom } from 'rxjs';
import { CaseState } from '../../_types/case-state';
import { Client } from 'src/app/modules/clients/_types/client';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation, HasFilter } from 'src/app/core/jsonapi/filter';
import { CasesStatesService } from '../../_services/cases-states.service';
import { ClientsService } from 'src/app/modules/clients/_services/clients.service';
import { ClientsDetailComponent } from 'src/app/modules/clients/clients-detail/clients-detail.component';
import { CasesTypesService } from 'src/app/modules/cases-types/_services/cases-types.service';
import { CaseType } from 'src/app/modules/cases-types/_types/case-type';
import { ContractsService } from 'src/app/modules/companies/_services/contracts.service';
import { ClientPolicy } from 'src/app/modules/clients/_types/client-policy';
import { ClientPoliciesService } from 'src/app/modules/clients/_services/clients-policies.service';
import { ClientPolicyComponent } from 'src/app/modules/clients/client-policy/client-policy.component';
import { CountriesRegionsService } from 'src/app/modules/common/_services/countries-regions.service';
import { CountriesService } from 'src/app/modules/common/_services/countries.service';
import { AddressesService } from 'src/app/modules/common/_services/addresses.service';
import { CasesTreatmentsService } from '../../_services/cases-treatments.service';
import { CaseTreatment } from '../../_types/case-treatment';
import { Address } from 'src/app/modules/common/_types/address';
import { LoginService } from 'src/app/modules/login/login.service';
import { CasesModesService } from '../../_services/cases-modes.service';
import { Contract } from 'src/app/modules/companies/_types/contract';
import { CaseMode } from '../../_types/case-mode';
import { ThirdPartiesService } from 'src/app/modules/transactions/_services/third-parties.service';
import { CompanyCaseModeService } from 'src/app/modules/companies/_services/company-case-mode.service';

@Component({
    selector: 'app-general',
    templateUrl: './general.component.html',
    styleUrls: ['./general.component.scss'],
    standalone: false
})
export class CasesDetailGeneralComponent {
  public caseFormGroup!: RxFormGroup;

  public case: Case = new Case();
  public companies: Company[] = [];
  public caseTypes: CaseType[] = [];
  public caseStates: CaseState[] = [];
  public clients: Client[] = [];
  public clientPolicies: ClientPolicy[] = [];
  public contracts: any[] = [];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public countries: any = [];
  public countriesRegions: any = [];
  public timespan: string = new Date().toISOString();
  public casesTreatments: CaseTreatment[] = [];
  public caseModes: any[] = [];
  public selectedContract?: Contract;
  public dropdownTipeAddress: any[] = [
    { label: 'Misma del cliente', value: 'CLIENT' },
    { label: 'Otra dirección', value: 'OTHER' }
  ];
  public dropdownTipeAddressId: string = 'CLIENT';
  public addressId: string | null = null;
  public isCreating: boolean = false;

  //popup que se muestra al marcar el expediente como urgente
  public showUrgentDialog: boolean = false;
  public assignmentPendingState?: CaseState;
  public urgentRevisionDate: Date = new Date();


  //snapshot para saber si hay que volver a geoposicionar al guardar: solo si cambian estos campos o se pasa a dirección distinta de la del cliente
  private originalDropdownTipeAddressId: string = 'CLIENT';
  private originalAddressLine1?: string;
  private originalCity?: string;
  private originalZipCode?: string;


  constructor(
    private casesService: CasesService,
    private companiesService: CompaniesService,
    private casesTypesService: CasesTypesService,
    private casesStatesService: CasesStatesService,
    private clientsService: ClientsService,
    private clientPoliciesService: ClientPoliciesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private dialogService: DialogService,
    private contractsService: ContractsService,
    private countriesRegionsService: CountriesRegionsService,
    private countriesService: CountriesService,
    private addressesService: AddressesService,
    private casestreatmentsService: CasesTreatmentsService,
    private loginService: LoginService,
    private caseModeService: CasesModesService,
    private companyCaseModeService: CompanyCaseModeService
  ) {

    if (this.case.address == null) this.case.address = new Address();
    this.case.caseStateMetadata = "";
    this.caseFormGroup = this.formBuilder.formGroup<Case>(this.case) as RxFormGroup;
    this.caseFormGroup.get('reference')?.disable();
  }

  async ngOnInit() {
    await this.loadCaseModes();
    await this.loadClients(null);
    this.loadCountries();
    this.loadCountriesRegions();
    this.loadCasesTreatments();

    let id = this.config.data.id;
    this.isCreating = id == null || id == '0';
    if (id != null && id != '0') {
      await this.loadCompanies();
      await this.loadCase(id);
      await this.loadContracts();
      await this.loadClientPolicies();
    } else {
      await this.loadInitialState();
     
      this.case.caseModeId = this.caseModes.filter((m: any) => m.code == "SINISTER")[0]?.id;
      this.caseFormGroup.patchValue({ caseModeId: this.case.caseModeId, caseStateId: this.case.caseStateId });
      await this.loadCompanies();
    }
    this.loadCaseTypes();
    this.loadCaseStates();
    this.allowWrite = this.loginService.hasPermission("CASES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");
  }

  async loadCase(id: string) {
    this.case = await firstValueFrom(this.casesService.get(id, { include: ['company', 'client', 'processor', 'address', 'caseState'] }));
    this.caseFormGroup.patchValue(this.case);

    this.addressId = this.case.addressId ?? this.case.client?.addressId;
    this.dropdownTipeAddressId = this.addressId != this.case.client?.addressId ? "OTHER" : "CLIENT";

    //snapshot del estado cargado, para saber en save() si hay que volver a geoposicionar
    this.originalDropdownTipeAddressId = this.dropdownTipeAddressId;
    this.originalAddressLine1 = this.case.address?.addressLine1;
    this.originalCity = this.case.address?.city;
    this.originalZipCode = this.case.address?.zipCode;

    //Buscamos si se el asegurado se encuentra en la lista de clientes
    if (this.clients.filter(m => m.id == this.case.clientId).length == 0) {
      this.clients.push(this.case.client!);
    }
  }

  async loadCaseModes() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.caseModeService.all(params));
    this.caseModes = response.data;

  }

  async loadCompanies() {
    let params: IParamsCollection = {
      sort: ['name']
    };

    if (this.isCreating && this.caseFormGroup.get('caseModeId')?.value) {
      let caseModeRelationFilters = {
        caseModeId: new Filter(FilterOperation.equals, 'caseModeId', '', this.caseFormGroup.get('caseModeId')?.value)
      };
      let caseModeRelationParams: IParamsCollection = {
        page: { number: 1, size: 10000 },
        filter: FilterBuilder.fromObject(caseModeRelationFilters).build()
      };

      let relationsResponse = await firstValueFrom(this.companyCaseModeService.all(caseModeRelationParams));
      let companyIds = [...new Set(relationsResponse.data.map((item: any) => item.companyId))];

      if (companyIds.length === 0) {
        this.companies = [];
        this.caseFormGroup.patchValue({ companyId: null, contractId: null });
        this.contracts = [];
        this.selectedContract = undefined;
        return;
      }

      params.filter = FilterBuilder.fromObject({
        id: new Filter(FilterOperation.any, 'id', '', companyIds)
      }).build();
    }

    let response = await firstValueFrom(this.companiesService.all(params));
    this.companies = response.data;

    let currentCompanyId = this.caseFormGroup.get('companyId')?.value;
    if (currentCompanyId && !this.companies.some((company: Company) => company.id === currentCompanyId)) {
      this.caseFormGroup.patchValue({ companyId: null, contractId: null });
      this.contracts = [];
      this.selectedContract = undefined;
    }
  }

  async loadContracts() {
    let filters = {
      companyId: new Filter(FilterOperation.equals, 'companyId', "", this.caseFormGroup.value.companyId)
    };

    let params: IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractsService.all(params));
    this.contracts = response.data;

    if (this.contracts.length === 1) {
      let singleContractId = this.contracts[0].id;
      this.caseFormGroup.patchValue({ contractId: singleContractId });
      await this.onSelectContract();
      return;
    }

    let currentContractId = this.caseFormGroup.get('contractId')?.value;
    if (currentContractId && !this.contracts.some((contract: any) => contract.id === currentContractId)) {
      this.caseFormGroup.patchValue({ contractId: null });
      this.selectedContract = undefined;
    }
  }

  async loadClients(event: any) {
    let text = "";
    if (event != null) text = event.filter;
    let filters = { name: new Filter(FilterOperation.contains, 'name', "") };

    if (event != null) {
      filters.name = new Filter(FilterOperation.contains, 'name', "", text)
    }
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build(),
      page: { size: 500 }
    };

    let response = await firstValueFrom(this.clientsService.all(params));
    this.clients = response.data;
    if (this.case && this.case.clientId && this.case.clientId != null) {
      if (this.clients.filter(m => m.id == this.case.clientId).length == 0) {
        this.clients.push(this.case.client!);
      }
    }
  }
  async loadClientInfo() {

    var clientAddressId = this.clients.filter(m => m.id == this.caseFormGroup.value.clientId && m.addressId != null).map(m => m.addressId);

    if (clientAddressId.length > 0) {
      //Cargamos la dirección del cliente.
      let clientAddress = await firstValueFrom(this.addressesService.get(clientAddressId[0]));
      var address = clientAddress;
      /*var address = new Address();
      address.addressLine1 = clientAddress.addressLine1;
      address.addressLine2 = clientAddress.addressLine2;
      address.zipCode = clientAddress.zipCode;
      address.city = clientAddress.city;
      address.countryCode = clientAddress.countryCode;
      address.countryRegionId = clientAddress.countryRegionId;*/
      this.caseFormGroup.patchValue({ address: address });
    }

    this.loadClientPolicies();
  }
  async loadClientPolicies() {
    let filters = {
      clientId: new Filter(FilterOperation.equals, 'clientId', "", this.caseFormGroup.value.clientId)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['insuranceCompany']
    };

    let response = await firstValueFrom(this.clientPoliciesService.all(params));
    this.clientPolicies = response.data;
  }


  async loadCaseTypes() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let caseMode = this.caseModes.find((m: CaseMode) => m.id == this.caseFormGroup.get('caseModeId')?.value);
    if (caseMode != null) {
      //filtro por relacion: pendiente de verificar contra la API que JsonApiDotNetCore acepte la cadena caseMode.code dentro de has()
      let filter = {
        caseMode: new HasFilter('caseModes',
          new Filter(FilterOperation.equals, 'caseMode.code', '', caseMode.code))
      };
      params.filter = FilterBuilder.fromObject(filter).build();
    }
    let response = await firstValueFrom(this.casesTypesService.all(params));
    this.caseTypes = response.data;
  }

  async loadCaseStates() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let caseMode = this.caseModes.find((m: CaseMode) => m.id == this.caseFormGroup.get('caseModeId')?.value);
    if (caseMode != null) {
      //filtro por relacion: pendiente de verificar contra la API que JsonApiDotNetCore acepte la cadena caseMode.code dentro de has()
      let filter = {
        caseMode: new HasFilter('caseModes',
          new Filter(FilterOperation.equals, 'caseMode.code', '', caseMode.code))
      };
      params.filter = FilterBuilder.fromObject(filter).build();
    }
    let response = await firstValueFrom(this.casesStatesService.all(params));
    this.caseStates = response.data
  }

  async loadInitialState() {
    let params: IParamsCollection = {}
    let filters = {
      isInitial: new Filter(FilterOperation.equals, 'isInitial', '', true)
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesStatesService.all(params));

    if (response.data) {
      var assignmentPendingState = response.data.filter((m: any) => m.code == "TRAMITATION_PENDING")[0] ?? response.data[0];
      this.case.caseStateId = assignmentPendingState.id ?? '';
    }
  }

  async loadCasesTreatments() {
    let response = await firstValueFrom(this.casestreatmentsService.all());
    this.casesTreatments = response.data;
    if (this.isCreating) {
      var caseTreatmentId = this.casesTreatments.filter(m => m.isDefault)[0]?.id;
      if (caseTreatmentId != null) this.case.caseTreatmentId = caseTreatmentId;
    }
  }

  async onSelectCaseMode() {
    if (this.isCreating) {
      await this.loadCompanies();
      await this.loadContracts();
    }
    await this.loadCaseTypes();
    await this.loadCaseStates();
  }

  async onSelectContract() {
    this.selectedContract = this.contracts.filter((m: any) => m.id == this.caseFormGroup.value.contractId)[0];
    /*if(this.selectedContract!=null && this.selectedContract.enableCaseNumberGenerate){
      this.caseFormGroup.patchValue({ caseNumber: "" });
    } no parece que tenga sentido.*/
  }

  //Al marcar el expediente como urgente ofrecemos pasarlo a "Pendiente de asignaciones" con fecha de revisión de hoy:
  async onUrgentChange(event: any) {
    //sólo al marcarlo; al desmarcar no se hace nada
    if (event?.checked !== true) return;

    this.assignmentPendingState = await this.loadAssignmentPendingState();
    if (this.assignmentPendingState == null) {
      this.messageService.add({ closable: true, severity: 'warn', summary: "Aviso", detail: "No se ha encontrado el estado con código ASSIGNMENT_PENDING." });
      return;
    }

    this.urgentRevisionDate = new Date();
    this.urgentRevisionDate.setHours(0, 0, 0, 0);
    this.showUrgentDialog = true;
  }

  //si acepta ponemos el estado y la fecha de revisión en el formulario; se guardan con el resto del expediente
  acceptUrgentChange() {
    this.caseFormGroup.patchValue({
      caseStateId: this.assignmentPendingState!.id,
      revisionDate: this.urgentRevisionDate
    });
    this.showUrgentDialog = false;
    this.messageService.add({ closable: true, severity: 'info', detail: "Se pasará a " + this.assignmentPendingState!.name + " con fecha de revisión " + this.urgentRevisionDate.toLocaleDateString('es-ES') + " al guardar." });
  }

  //si cancela no se hace nada: el expediente queda marcado como urgente sin tocar estado ni fecha de revisión
  cancelUrgentChange() {
    this.showUrgentDialog = false;
  }

  //el estado puede no estar en this.caseStates si no está habilitado para el tipo de expediente, así que lo buscamos también por código
  private async loadAssignmentPendingState(): Promise<CaseState | undefined> {
    let state = this.caseStates.find((m: CaseState) => m.code == 'ASSIGNMENT_PENDING');
    if (state != null) return state;

    let filters = {
      code: new Filter(FilterOperation.equals, 'code', '', 'ASSIGNMENT_PENDING')
    };
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.casesStatesService.all(params));
    state = response.data[0];

    //lo añadimos a las opciones del desplegable para que pueda mostrarse como estado seleccionado
    if (state != null) this.caseStates.push(state);
    return state;
  }

  async save() {

    let valid = this.formValidationService.validateForm(this.caseFormGroup);
    if (valid) {


      this.case = Object.assign(this.case, this.caseFormGroup.value);


      var checkIfExist = false;
      if (!this.case.id) {
        //validamos si ya existe un expediente con el mismo contrato e id de expediente
        checkIfExist = await firstValueFrom(this.casesService.caseSameNumberAndContract(this.case.caseNumber, this.case.contractId, this.case.id ?? ""));
      }
      if (checkIfExist) {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Ya existe un expediente con el mismo número y contrato." });
        return;
      }

      if (this.case.address != null) {
        console.log("Saving address: ", this.case.address);
        let address: any = await firstValueFrom(this.addressesService.save(this.case.address));
        this.case.addressId = address.id;

        //solo geoposicionamos si ha cambiado algo relevante para la geocodificación o si se ha pasado a una dirección distinta de la del cliente
        let addressFieldsChanged =
          this.case.address.addressLine1 !== this.originalAddressLine1 ||
          this.case.address.city !== this.originalCity ||
          this.case.address.zipCode !== this.originalZipCode;
        let changedToOtherAddress = this.dropdownTipeAddressId === "OTHER" && this.originalDropdownTipeAddressId !== "OTHER";

        if (addressFieldsChanged || changedToOtherAddress) {
          //geoposiciona la dirección y guarda latitud/longitud; lanza error si Google no puede resolverla
          this.case.address = await firstValueFrom(this.addressesService.geocode(address.id));
        }
      }

      let caseItem = await firstValueFrom(this.casesService.save(this.case));
      let selectedCaseMode = this.caseModes.find((m: any) => m.id == this.caseFormGroup.get('caseModeId')?.value);

      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Expediente guardado correctamente." });
      this.dynamicDialogRef.close({ id: caseItem.id, caseModeCode: selectedCaseMode?.code });

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el expediente?",
      header: "Eliminar expediente",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesService.delete(this.case.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Expediente eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  async editClient(clientId: string | null) {
    let selectedCaseMode = this.caseModes.find((m: any) => m.id == this.caseFormGroup.get('caseModeId')?.value);

    let ref = this.dialogService.open(ClientsDetailComponent, {
      closable: true,
      modal: true,
      header: clientId != null ? 'Editar cliente' : 'Nuevo cliente',
      width: '900px',
      data: {
        id: clientId
      }
    });

    ref.onClose.subscribe(async (data: Client) => {
      if (data != null) {
        this.loadClients({ filter: data.name });
        this.case.clientId = data.id!;
        this.caseFormGroup.patchValue({ clientId: data.id });
        this.loadClientInfo();
      }
    });

    //ajuste para resolver error de foco
    const dynamicDialogComponent = this.dialogService.dialogComponentRefMap.get(this.dynamicDialogRef);
    if (dynamicDialogComponent) {
      // unbind tab/esc buttons listeners
      dynamicDialogComponent.instance.unbindGlobalListeners();

      // when the second modal is closed/destroyed then
      ref.onDestroy.pipe(first()).subscribe(() => {
        // reinitialize the first modal
        dynamicDialogComponent.instance.moveOnTop(); // we need this for properly Esc button handler
        dynamicDialogComponent.instance.bindGlobalListeners(); // bind tab/esc buttons listeners
        dynamicDialogComponent.instance.focus(); // apply [autofocus] if any
      });
    }

  }

  async editClientPolicy(clientId: string, clientPolicyId: string | null) {

    let ref = this.dialogService.open(ClientPolicyComponent, {
      closable: true,
      modal: true,
      header: 'Nueva póliza',
      width: '900px',
      data: {
        id: clientPolicyId,
        clientId: clientId
      }
    });

    ref.onClose.subscribe(async (data: ClientPolicy) => {
      if (data != null) {
        this.loadClientPolicies();
        this.case.clientPolicyId = data.id!;
        this.caseFormGroup.patchValue({ clientPolicyId: data.id });
      }
    });

    //ajuste para resolver error de foco
    const dynamicDialogComponent = this.dialogService.dialogComponentRefMap.get(this.dynamicDialogRef);
    if (dynamicDialogComponent) {
      // unbind tab/esc buttons listeners
      dynamicDialogComponent.instance.unbindGlobalListeners();

      // when the second modal is closed/destroyed then
      ref.onDestroy.pipe(first()).subscribe(() => {
        // reinitialize the first modal
        dynamicDialogComponent.instance.moveOnTop(); // we need this for properly Esc button handler
        dynamicDialogComponent.instance.bindGlobalListeners(); // bind tab/esc buttons listeners
        dynamicDialogComponent.instance.focus(); // apply [autofocus] if any
      });
    }

  }

  async loadCountriesRegions() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.countriesRegionsService.all(params));
    this.countriesRegions = response.data;
  }

  async loadCountries() {
    let countryId = null;
    if (this.caseFormGroup.value.address?.countryRegionId != null) {
      let country = this.countriesRegions.find((m: any) => m.id == this.case.address?.countryRegionId);
      if (country != null) countryId = country.countryId;
    }
    let params: IParamsCollection = {
      sort: ['name'],
    };
    if (countryId != null) {
      let filters = {
        id: new Filter(FilterOperation.equals, 'id', "", countryId)
      };
      params.filter = FilterBuilder.fromObject(filters).build();
    }
    let response = await firstValueFrom(this.countriesService.all(params));
    this.countries = response.data;
  }

  async changeAddress() {
    if (this.dropdownTipeAddressId == "OTHER") {
      // this.addressId = null;
      var address = new Address();
      if (this.case.client && this.case.client.address) {
        address.addressLine1 = this.case.client?.address.addressLine1;
        address.addressLine2 = this.case.client?.address.addressLine2;
        address.zipCode = this.case.client?.address.zipCode;
        address.city = this.case.client?.address.city;
        address.countryCode = this.case.client?.address.countryCode;
        address.countryRegionId = this.case.client?.address.countryRegionId;
      }
      this.caseFormGroup.patchValue({ address: address });
    } else {

      let clientAddress = await firstValueFrom(this.addressesService.get(this.case.addressId));

      this.caseFormGroup.patchValue({ address: clientAddress });
      //this.case.addressId = this.case.client?.addressId;
    }
  }

}
